import { AppButton } from 'components';
import ChapterSearch from 'components/molecules/ChapterSearch';
import CoursesSearch from 'components/molecules/CoursesSearch';
import LessonsSearch from 'components/molecules/LessonsSearch';
import {
  AppModal,
  AppModalBody,
  // AppModalFooter,
  AppModalHeader,
} from 'components/molecules/Modal/AppModal';
import useCloneChapter from 'hooks/API/POST/useCloneChapter';
import useCloneSubTopic from 'hooks/API/POST/useCloneSubTopic';
import useCloneTopic from 'hooks/API/POST/useCloneTopic';
// import useToaster from 'hooks/useToaster';
import { memo, useEffect, useState } from 'react';
import ESTDropDownType1 from 'components/molecules/ESTDropDownType1';
import ESDropDown from 'components/molecules/ESDropDown';
import ESClassDropDown from 'components/molecules/ESClassDropDown';
import * as AppPics from 'assets/images';

function CopyContentsModal({ open, closeModal, data = {} }) {
  const { chapterID, classID, topicID, subTopicID, isCopy = false } = data;
  const [courseInfo, setCourseInfo] = useState(Object.assign({}, initialState));
  const [courses, setCourses] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [topics, setTopics] = useState([]);

  useEffect(() => {}, []);

  function clearArray() {
    setCourses([]);
    setChapters([]);
    setTopics([]);
  }

  function handleInfoChange(data = {}) {
    setCourseInfo((x) => ({ ...x, ...data }));
    clearArray();
  }

  const __cloneChapter = useCloneChapter({ classID });
  const __cloneTopic = useCloneTopic({ classID, chapterID });
  const __cloneSubTopic = useCloneSubTopic({ classID, chapterID, topicID });

  // useToaster(__cloneChapter.isLoading, { type: __cloneChapter.isError ? 'error' : 'success' });

  const allCourses = !Object.values(courseInfo).some((x) => x);
  const handleClose = () => {
    closeModal();
  };
  return (
    <AppModal
      open={open}
      closeModal={closeModal}
      size="lg"
      // popUpProps={{ className: '__appModalMinHeight' }}
    >
      <AppModalHeader>
        {data?.subTopicID ? 'Copy Sub Lesson' : data?.topicID ? 'Copy Lesson' : 'Copy Chapter'}
      </AppModalHeader>
      <AppModalBody classNames="p-4">
        <div className="row mb-4">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <ESTDropDownType1
              enableAPI
              value={courseInfo.est}
              handleChange={(event) => {
                const est = event.target.value;
                setCourseInfo((x) => ({ ...initialState, est }));
                clearArray();
              }}
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4">
            <ESDropDown
              enableAPI={!!courseInfo.est}
              dependencies={{
                query: courseInfo.est ? `est=${courseInfo.est}` : ``,
              }}
              value={courseInfo.es}
              handleChange={(event) => {
                const es = event.target.value;
                handleInfoChange({ es, classId: '' });
              }}
              defaultLook={false}
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4">
            <ESClassDropDown
              enableAPI={!!courseInfo.es}
              dependencies={{
                query: `esId=${courseInfo.es}`,
              }}
              value={courseInfo.classId}
              handleChange={(event) => {
                const classId = event.target.value;
                handleInfoChange({ classId });
              }}
              defaultLook={false}
            />
          </div>
        </div>
        <div className="my-4">
          <CoursesSearch
            enableAPI
            dependencies={{
              query: {
                allCourses,
                esId: courseInfo.es,
                estId: courseInfo.est,
                classId: courseInfo.classId,
              },
            }}
            values={courses}
            handleChange={(data = []) => {
              setCourses(data);
            }}
          />
        </div>
        {topicID && (
          <div className="my-4">
            <ChapterSearch
              enableAPI={courses.length > 0}
              // dependencies={{
              //   query: {},
              //   classID,
              //   courseID: courses[0]?._id,
              // }}
              dependencies={{
                query: {
                  esId: courseInfo.es,
                  estId: courseInfo.est,
                  classId: courseInfo.classId || 'all',
                },
                classID: courseInfo.classId || 'all',
                courseID: courses[0]?._id,
              }}
              values={chapters}
              handleChange={(data) => {
                setChapters(data);
              }}
            />
          </div>
        )}
        {subTopicID && (
          <div className="my-4">
            <LessonsSearch
              enableAPI={chapters.length > 0}
              dependencies={{
                query: {},
                classID,
                courseID: courses[0]?._id,
                chapterID: chapters[0]?._id,
              }}
              values={topics}
              handleChange={(data) => {
                setTopics(data);
              }}
            />
          </div>
        )}
        <div className="d-flex flex-row mt-4 justify-content-center">
          {chapterID && !topicID && !subTopicID && (
            <>
              <AppButton
                variantClass="btn-primary mx-3 d-flex align-items-center"
                style={{ minWidth: '1.5rem' }}
                onClick={() => {
                  if (__cloneChapter.isLoading) return;

                  __cloneChapter.mutate(
                    {
                      chapters: [chapterID],
                      courses: courses.map((x) => x._id),
                      isCopy: isCopy,
                    },
                    {
                      onSuccess() {
                        closeModal();
                      },
                    }
                  );
                }}
              >
                {__cloneChapter.isLoading ? 'Copying...' : 'Copy'}{' '}
                <img className="_sv_ico" src={AppPics.CopySvgInvert} alt="Copy" />
              </AppButton>
            </>
          )}
          {topicID && !subTopicID && (
            <>
              <AppButton
                variantClass="btn-primary mx-3 d-flex align-items-center"
                style={{ minWidth: '1.5rem' }}
                onClick={() => {
                  if (__cloneTopic.isLoading) return;
                  if (!chapters[0]?._id) {
                    window.alert('Please pick a chapter!');
                    return;
                  }

                  __cloneTopic.mutate(
                    {
                      topics: [topicID],
                      chapters: [chapters[0]?._id],
                      courses: courses.map((x) => x._id),
                      isCopy: isCopy,
                    },
                    {
                      onSuccess() {
                        closeModal();
                      },
                    }
                  );
                }}
              >
                {__cloneTopic.isLoading ? 'Copying...' : 'Copy'}{' '}
                <img className="_sv_ico" src={AppPics.CopySvgInvert} alt="Copy" />
              </AppButton>
            </>
          )}
          {topicID && subTopicID && (
            <>
              <AppButton
                variantClass="btn-primary mx-3 d-flex align-items-center"
                style={{ minWidth: '1.5rem' }}
                onClick={() => {
                  if (__cloneSubTopic.isLoading) return;
                  if (!chapters[0]?._id) {
                    window.alert('Please pick a chapter!');
                    return;
                  }
                  if (!topics[0]?._id) {
                    window.alert('Please pick a topic!');
                    return;
                  }

                  __cloneSubTopic.mutate(
                    {
                      chapters: [chapters[0]?._id],
                      courses: courses.map((x) => x._id),
                      lessons: [topics[0]?._id],
                      subtopics: [subTopicID],
                      isCopy: isCopy,
                    },
                    {
                      onSuccess() {
                        closeModal();
                      },
                    }
                  );
                }}
              >
                {__cloneTopic.isLoading ? 'Copying...' : 'Copy'}{' '}
                <img className="_sv_ico" src={AppPics.CopySvgInvert} alt="Copy" />
              </AppButton>
            </>
          )}
          <AppButton variantClass="btn-plane p--tint mx-4  -outline-" onClick={closeModal}>
            Cancel
          </AppButton>
        </div>
      </AppModalBody>
    </AppModal>
  );
}

const initialState = {
  classId: '',
  est: '',
  es: '',
};

export default memo(CopyContentsModal);
